// extracted by mini-css-extract-plugin
module.exports = {"soundSwitch":"SoundSwitch_soundSwitch__gm-Oj","button":"SoundSwitch_button__TbCra","_active":"SoundSwitch__active__2ohN6","separator":"SoundSwitch_separator__2fiw6"};